/* 🤖 this file was generated by svg-to-ts */
export const matIconHdrOn: {
  name: 'hdr-on';
  data: string;
} = {
  name: 'hdr-on',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"/></svg>`
};
